import Swiper from './swiper.min.js';
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/pagination.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';
import Thumbs from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/thumbs.min.mjs';
import Autoplay from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/autoplay.min.mjs';
import EffectFade from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/effect-fade.min.mjs';

// Toevoegen aan winkelwagen (okt 2026: via event delegation, zodat ook producten die later
// geladen worden -- oneindig scrollen, filteren -- direct werken)
document.addEventListener('submit', async (event) => {
    const form = event.target.closest && event.target.closest('.add-to-cart-form');
    if (!form) return;
    event.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const formData = new FormData(form);
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            if (response.status === 429) {
                throw new Error('Rate limit hit (429). Please try again in a few seconds.');
            }
            throw new Error('Failed to add product to cart');
        }

        if (btn) {
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1600);
        }

        // On success, open the side cart
        const sidecart = document.querySelector('side-cart');
        sidecart?.openCart();
    } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Er ging iets mis bij het toevoegen aan je winkelwagen. Probeer het nog eens.');
    }
});



document.getElementById('js__open-menu').addEventListener('click', function() {
    document.getElementById('mobile-menu').classList.remove('hidden')
    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
        document.getElementById('mobile-menu').classList.add('active')
    }, 10);
})

document.querySelectorAll('.js__close-menu').forEach(function(btn) {
    btn.addEventListener('click', function() {
        document.getElementById('mobile-menu').classList.remove('active')
        document.body.classList.remove('overflow-hidden');
        setTimeout(() => {
            document.getElementById('mobile-menu').classList.add('hidden')
        }, 300);
    })
})

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.currentTarget.name === 'plus'
      ? this.input.stepUp()
      : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)


class HeroBanner extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const swiper = new Swiper(this, {
        loop: true,
        modules: [Autoplay, EffectFade],
        autoplay: {
            delay: 5000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    });
  }
}
customElements.define("hero-banner", HeroBanner);



class SideCart extends HTMLElement {
  constructor() {
    super(); 
  }

  connectedCallback() {
    this.updateQuantity(); // Initialize quantity update listeners
    this.checkParam(); // Check url for cart param

    const self = this;
    // Listener to open the sidecart on click
    document.querySelectorAll(".open-sidecart").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault()
        self.openCart(); // Call the method to open the cart
      });
    });

    this.initCartNoteSaving();
  }

  // Function to open the side cart with a slide-in animation
  openCart() {
    this.classList.remove("translate-x-full"); // Remove the class that hides the cart
    document.body.classList.add('overflow-hidden')

    setTimeout(() => {
      this.querySelector(".side-cart-overlay").classList.remove("hidden"); // Show the overlay after a delay
    }, 300);
    this.renderCart(); // Render the cart content
  }

  // Function to check the URL parameter for cart opening
  checkParam() {
    let params = new URLSearchParams(document.location.search);
    let cartOpen = params.get("cart_open");
    if (cartOpen === 'true') {
      this.openCart();
    };
  }
initCartNoteSaving() {
  // Remove previous listeners if any (safety)
  const oldNoteField = this.querySelector('#SideCartNote');
  if (oldNoteField) {
    oldNoteField.replaceWith(oldNoteField.cloneNode(true)); // brutal but effective way to remove old listeners
  }

  const noteField = this.querySelector('#SideCartNote');
  if (!noteField) {
    console.warn('SideCartNote textarea not found in DOM');
    return;
  }

  let saveTimeout;

  const saveNote = () => {
    const noteValue = noteField.value;

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ note: noteValue })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }
      console.log('Cart note saved');
    })
    .catch(err => {
      console.error('Failed to save cart note:', err);
    });
  };

  // Debounced save
  noteField.addEventListener('input', () => {
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(saveNote, 700);
  });

  // Save before important actions
  this.querySelectorAll('.sidecart__close-cart, .sidecart__checkout').forEach(el => {
    el.addEventListener('click', () => {
      clearTimeout(saveTimeout);
      saveNote();
    }, { once: true }); // once → prevents multiple bindings
  });
}


  // Function to render the cart using the Shopify section API
  renderCart() {
    const self = this;

    // Fetch the updated cart data
    fetch(window.Shopify.routes.root + "?sections=sidecart")
      .then((res) => res.json()) 
      .then((data) => {
        let html = document.createElement("div"); // Create a temporary element to hold the HTML
        html.innerHTML = data.sidecart; // Set the inner HTML to the fetched sidecart content
        
        // Update the cart elements with new data
        document.querySelector('.sidecart__wrapper').dataset.count = html.querySelector('.sidecart__wrapper').dataset.count;
        document.querySelector(".sidecart__inner").innerHTML = html.querySelector(".sidecart__inner").innerHTML;
        document.querySelector(".sidecart__title").innerHTML = html.querySelector(".sidecart__title").innerHTML;
        document.querySelector(".side-cart__total--container").innerHTML = html.querySelector(".side-cart__total--container").innerHTML;

        // Update progress text and line width
        if(document.querySelector("#cart-progress-text")) {
          document.querySelector("#cart-progress-text").innerHTML = html.querySelector("#cart-progress-text").innerHTML;
          document.querySelector('#cart-progress-line').style.width = html.querySelector('#cart-progress-line').style.width;
        }


        // Update the cart count in the header
        document.querySelectorAll('.cart-header-count').forEach(function(el) {
          el.innerHTML = html.querySelector("#sidecart-inner").dataset.count;
        })
        
        if(html.querySelector("#sidecart-inner").dataset.count == 0) {
          document.querySelectorAll('.header-cart-icon').forEach(el => el.classList.add('hidden'))
          document.querySelectorAll('.header-empty-cart-icon').forEach(el => el.classList.remove('hidden'))
        } else{
          document.querySelectorAll('.header-cart-icon').forEach(el => el.classList.remove('hidden'))
          document.querySelectorAll('.header-empty-cart-icon').forEach(el => el.classList.add('hidden'))
        }

        // Event listener to close the sidecart
        document.querySelectorAll(".sidecart__close-cart").forEach((close) => {
          close.addEventListener("click", () => {
            self.querySelector(".side-cart-overlay").classList.add("hidden"); // Hide the overlay
            document.body.classList.remove('overflow-hidden')// Clear body scroll locks
            self.classList.add("translate-x-full"); // Reapply the class to hide the cart
          });
        });

        self.productsCarousel()
        self.initCartNoteSaving()
        // Suggesties in de winkelwagen (okt 2026): op basis van wat er in de winkelwagen zit
        if (window.zwLoadCartRecs) window.zwLoadCartRecs();
        const noteField = document.querySelector('#SideCartNote');
        if (noteField) {

          fetch(window.Shopify.routes.root + 'cart.js')
            .then(res => res.json())
            .then(cart => {
              if (noteField.value !== cart.note) {
                noteField.value = cart.note || '';
              }
            })
            .catch(() => {});
        }
      });
  }

  // Listen for quantity updates
  updateQuantity() {
    const self = this;

    this.addEventListener("click", function (e) {
      let target = e.target;

      // Handle quantity button clicks
      if (target.classList.contains("quantity__button")) {
        target.closest(".sidecart-item").classList.add("opacity-50"); 

        let input = target.closest("quantity-input").querySelector("input");
        let key = input.dataset.key; 
        let value = input.value; 

        self.changeRequest(key, value); 
      }

      // Handle item removal from the cart
      if (target.classList.contains("sidecart__remove")) {
        target.closest(".sidecart-item").classList.add("opacity-50"); 

        let id = target.dataset.id; 
        self.changeRequest(id, 0); 
      }
    });
  }

  // Add a product to the cart
  addToCart(id) {
    const self = this;

    let productData = {
      id: id,
      quantity: 1, 
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(productData), 
    })
    .then((response) => response.json()) 
    .then((data) => {
      self.renderCart()
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error); 
    });
  }

  // Change the quantity of a product or remove it from the cart
  changeRequest(id, qty, sellingPlan) {
    let obj = {
      id: id,
      quantity: qty,
    };

    if (sellingPlan) {
      obj.selling_plan = sellingPlan; 
    }

    const self = this;
    // Request to change the cart item
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj), 
    })
    .then((response) => response.json()) 
    .then((data) => {
      self.renderCart(); 
    })
    .catch((error) => {
      console.error("Error changing product quantity:", error); 
    });
  }

  productsCarousel() {
    const self = this
    const wrap = document.querySelector("cart-carousel-wrap");
    if (!wrap) return;
    // render the product carousel
    const swiper = new Swiper(wrap, {
      slidesPerView: 2,
      spaceBetween: 28,
      modules: [Pagination],
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });

    document.querySelectorAll(".cart_product_submit").forEach(function(btn) {
      btn.addEventListener("click", function () {
        let id = this.dataset.id;
        self.addToCart(id);
      });
    })
        
  }
  
}

customElements.define("side-cart", SideCart);


// 1FS - Hide secondary menu on scroll
// Aangepast okt 2026: verdwijnt bij naar beneden scrollen, komt terug bij naar boven scrollen
// (dan zwevend onder de kop, zodat de pagina niet verspringt).
document.addEventListener('DOMContentLoaded', () => {
    const secondaryMenu = document.querySelector('header div.secondary-menu'); 
    const header = document.querySelector('header');
    const hideThreshold = 45; 
    const showThreshold = 25;  

    if (secondaryMenu && header) {
        let lastY = window.scrollY;
        let ticking = false;

        const handleScroll = () => {
            const y = window.scrollY;
            const delta = y - lastY;
            if (y <= showThreshold) {
                header.classList.remove('menu-floating');
                secondaryMenu.classList.remove('secondary-menu-hidden');
            } else if (y > hideThreshold) {
                header.classList.add('menu-floating');
                if (delta > 6) {
                    secondaryMenu.classList.add('secondary-menu-hidden');
                } else if (delta < -6) {
                    secondaryMenu.classList.remove('secondary-menu-hidden');
                }
            }
            if (Math.abs(delta) > 6 || y <= showThreshold) lastY = y;
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(handleScroll);
            }
        }, { passive: true });
    }
});

// 1FS - Modify checkout button href for logged-in customers
(function() {
  'use strict';
  
  // Function to get customer ID from Shopify
  function getCustomerId() {
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
      return window.Shopify.customer.id;
    }
    const metaCustomer = document.querySelector('meta[name="shopify-customer-id"]');
    if (metaCustomer) {
      return metaCustomer.getAttribute('content');
    }
    return null;
  }
  
  // Function to modify checkout links
  function modifyCheckoutLinks() {
    const customerId = getCustomerId();
    
    if (!customerId) {
      return;
    }
    
    const discountCode = 'CUSTOMER-' + customerId;
    
    // Find all checkout links
    const checkoutLinks = document.querySelectorAll('a[href="/checkout"], a[href*="/checkout"]');
    
    checkoutLinks.forEach(function(link) {
      const currentHref = link.getAttribute('href');
      
      // Only modify if it doesn't already have the discount
      if (!currentHref.includes('discount=')) {
        const newHref = '/checkout?discount=' + encodeURIComponent(discountCode);
        link.setAttribute('href', newHref);
      }
    });
  }
  
  // Run immediately
  modifyCheckoutLinks();
  
  // Run when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', modifyCheckoutLinks);
  }
  
  // Watch for dynamically added checkout buttons
  const observer = new MutationObserver(modifyCheckoutLinks);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();